import React from 'react';
const C = { indigo:'bg-indigo-50 text-indigo-600', green:'bg-green-50 text-green-600', blue:'bg-blue-50 text-blue-600', amber:'bg-amber-50 text-amber-600', red:'bg-red-50 text-red-600', purple:'bg-purple-50 text-purple-600', orange:'bg-orange-50 text-orange-600' };
export function StatCard({ title, value, icon:Icon, color='indigo', subtitle }) {
  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
        {Icon && <div className={'w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ' + (C[color]||C.indigo)}><Icon className="w-5 h-5"/></div>}
      </div>
    </div>
  );
}